/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { JewelCrownIcon16Light } from './JewelCrownIcon16Light';
import { JewelCrownIcon16Regular } from './JewelCrownIcon16Regular';
import { JewelCrownIcon16Solid } from './JewelCrownIcon16Solid';
import { JewelCrownIcon20Light } from './JewelCrownIcon20Light';
import { JewelCrownIcon20Regular } from './JewelCrownIcon20Regular';
import { JewelCrownIcon20Solid } from './JewelCrownIcon20Solid';
import { JewelCrownIcon24Regular } from './JewelCrownIcon24Regular';
import { JewelCrownIcon24Solid } from './JewelCrownIcon24Solid';
import { JewelCrownIcon32Regular } from './JewelCrownIcon32Regular';
import { JewelCrownIcon64Regular } from './JewelCrownIcon64Regular';
var sizes = {
    16: {
        light: JewelCrownIcon16Light,
        regular: JewelCrownIcon16Regular,
        solid: JewelCrownIcon16Solid,
    },
    20: {
        light: JewelCrownIcon20Light,
        regular: JewelCrownIcon20Regular,
        solid: JewelCrownIcon20Solid,
    },
    24: {
        regular: JewelCrownIcon24Regular,
        solid: JewelCrownIcon24Solid,
    },
    32: {
        regular: JewelCrownIcon32Regular,
    },
    64: {
        regular: JewelCrownIcon64Regular,
    },
};
export var JewelCrownIcon = forwardRef('JewelCrownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
